import { render, staticRenderFns } from "./cus-editor.vue?vue&type=template&id=428a9be8&scoped=true"
import script from "./cus-editor.vue?vue&type=script&lang=js"
export * from "./cus-editor.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./cus-editor.vue?vue&type=style&index=1&id=428a9be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428a9be8",
  null
  
)

export default component.exports